import IColumnData from "../../../../common/interface/IColumnData";

export const FACTURA_COLUMN = (isAdmin: boolean): IColumnData[] => [
  {
    width: 100,
    label: "NRO. DOCUMENTO",
    dataKey: "documento",
  },
  ...(isAdmin
    ? [
        {
          width: 80,
          label: "CLIENTE",
          dataKey: "clienteId",
        },
      ]
    : []),
  {
    width: 40,
    label: "PARCELA",
    dataKey: "parcela",
  },
  {
    width: 60,
    label: "TIPO DE DOCUMENTO",
    dataKey: "tipo",
  },
  {
    width: 40,
    label: "VALOR",
    dataKey: "importe",
    numeric: true,
  },
  // {
  //     width: 40,
  //     label: 'MONEDA',
  //     dataKey: 'moneda',
  // },
  {
    width: 20,
    label: "DATA DE EMISSÃO",
    dataKey: "fechaEmision",
  },
  {
    width: 40,
    label: "VENCIMENTO",
    dataKey: "vencimiento",
  },
  {
    width: 40,
    label: "DATA DE ATUALIZAÇÃO",
    dataKey: "fechaActualizacion",
  },
  {
    width: 20,
    label: "DOWNLOAD",
    dataKey: "tienePdf",
    boolean: true,
  },
];
